import { render, staticRenderFns } from "./SaleInvoicesListFilters.vue?vue&type=template&id=47023158&scoped=true&"
import script from "./SaleInvoicesListFilters.vue?vue&type=script&lang=js&"
export * from "./SaleInvoicesListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47023158",
  null
  
)

export default component.exports